<template>
    <Head title="Features | Settings" />
    <div class="px-4 md:px-8" data-page="settings">
        <!-- Page header -->
        <div class="sm:flex sm:justify-between sm:items-center mb-10">
            <!-- Left: Title -->
            <div class="mb-4 sm:mb-0">
                <h1 class="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold">
                    Account Settings
                </h1>
            </div>
        </div>
        <!-- END PAGE HEADER -->

        <!-- TABLE -->
        <div
            class="lg:bg-white dark:bg-slate-800 dark:lg:bg-slate-800 lg:shadow-lg dark:lg:shadow-slate-900/50 lg:rounded-sm lg:border lg:border-gray-200 dark:lg:border-slate-700 mb-8"
        >
            <div class="flex flex-col lg:flex-row">
                <div
                    class="flex flex-nowrap p-0 lg:px-5 lg:py-10 bg-white dark:bg-slate-800 shadow-lg dark:shadow-slate-900/50 rounded-sm border border-gray-200 dark:border-slate-700 mb-8 lg:border-none lg:shadow-none"
                >
                    <SettingsNav />
                </div>

                <div
                    class="p-5 lg:px-0 lg:py-0 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-gray-200 mb-8 lg:mb-0 lg:border-r-0 lg:border-x-0 lg:border-y-0 lg:!border-l lg:!border-gray-200 lg:shadow-none"
                    style="grow: 1"
                >
                    <div class="flex flex-nowrap flex-col lg:px-10 lg:py-10">
                        <div class="mb-5">
                            <h2
                                class="text-xl lg:text-2xl text-gray-800 dark:text-gray-100 font-bold mb-5"
                            >
                                Features
                            </h2>

                            <section class="mb-8">
                                <h2
                                    class="text-xl lg:text-2xl leading-snug text-gray-800 dark:text-gray-100 font-bold mb-1"
                                >
                                    Manage Your Feature Preferences
                                </h2>

                                <div class="mb-8">
                                    <ul
                                        role="list"
                                        class="mt-2 mb-8 divide-y divide-gray-200 dark:divide-slate-700"
                                    >
                                        <li
                                            class="flex flex-col lg:flex-row justify-between py-4"
                                        >
                                            <div class="flex flex-col prose">
                                                <div class="lg:mb-8">
                                                    <h3
                                                        class="text-lg lg:text-xl text-gray-800 dark:text-gray-100 font-bold mb-2 !mt-0"
                                                        id="privacy-option-1-label"
                                                    >
                                                        Companion Pass Mode
                                                    </h3>
                                                    <p
                                                        class="text-sm text-gray-500 dark:text-gray-400"
                                                    >
                                                        Enable Companion Pass
                                                        Mode in order to be
                                                        easily guided
                                                        step-by-step throughout
                                                        the process for earning
                                                        the Southwest Companion
                                                        Pass.
                                                    </p>
                                                    <p
                                                        class="text-sm text-gray-500 dark:text-gray-400"
                                                    >
                                                        You'll receive timely
                                                        notifications guiding
                                                        you through each step so
                                                        that you don't miss a
                                                        beat, and track
                                                        everything easily right
                                                        in your My10x account.
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="relative mt-5">
                                                <CompanionPassToggle
                                                    :settings-page="true"
                                                />
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Layout from '@/Layouts/Main.vue';
import { Head, Link } from '@inertiajs/vue3';
import { ref, onMounted } from 'vue';
import CompanionPassToggle from '@/components/companion-pass/companion-pass-toggle.vue';
import SettingsNav from '@/Pages/Settings/partials/nav.vue';

const props = defineProps({
    userData: Object,
});

defineOptions({
    layout: Layout,
});
</script>
